var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "4102573_applications_facebook_media_social_icon 1",
    clipPath: "url(#clip0_0_18357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.55 0H2.45C1.0969 0 0 1.0969 0 2.45V11.55C0 12.9031 1.0969 14 2.45 14H11.55C12.9031 14 14 12.9031 14 11.55V2.45C14 1.0969 12.9031 0 11.55 0Z",
    fill: "#385997"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.8996 6.4751H9.71211V4.8126C9.71211 4.40572 10.1802 4.3751 10.3246 4.3751H11.8121V2.1001H10.3246C8.67742 2.1001 7.43711 3.26604 7.43711 4.8126V6.4751H5.59961V8.7501H7.43711V14.0001H9.71211V8.7501H11.5496L11.8996 6.4751Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_18357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.45602373cb7032da831ef43cfb48d032.svg";
export { ForwardRef as ReactComponent };